import "./footer.css";
import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__col">
        <div className="footer__heading">Get to Know Us</div>
        <li> Careers</li>
        <li>Blog</li>
        <li>About Amazon</li>
        <li>Press Center</li>
        <li>Investor Relations</li>
        <li>Amazon Devices</li>
        <li>Amazon Tours</li>
      </div>
      <div className="footer__col">
        <div className="footer__heading">Make Money with Us</div>
        <li> Sell products on Amazon</li>
        <li>Sell apps on Amazon</li>
        <li>Become an Affiliate </li>
        <li>Advertise Your Products</li>
        <li>Self-Publish with Us</li>
        <li>Host an Amazon Hub</li>
        <li>> See More Make Money with Us</li>
      </div>
      <div className="footer__col">
        <div className="footer__heading">Amazon Payment Products</div>
        <li> Amazon Rewards Visa Signature Cards</li>
        <li>Amazon.com Store Card</li>
        <li>Amazon Business Card </li>
        <li>Amazon Business Line of Credit</li>
        <li>Shop with points</li>
        <li>Credit Card Marketplace</li>
        <li>Reload Your Balance</li>
        <li>Amazon Currency Converter</li>
      </div>
      <div className="footer__col">
        <div className="footer__heading">Let Us Help You</div>
        <li>Amazon and COVID-19</li>
        <li>Your Account</li>
        <li>Your Orders</li>
        <li>Shipping Rates & Policies</li>
        <li>Amazon Prime</li>
        <li>Returns & Replacements</li>
        <li>Manage Your Content and Devices</li>
        <li>Amazon Assistant</li>
        <li>Help</li>
      </div>
    </div>
  );
}

export default Footer;
